import { Link } from "react-router-dom";
import { members } from "@/mocks/members";
import Reveal from "@/components/base/Reveal";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "话题先讲清楚",
    desc: "每个讨论区都有时间线和关键看点，先看清来龙去脉，再决定站哪一边。",
  },
  {
    icon: "ri-scales-3-line",
    title: "观点允许对撞",
    desc: "同一件事欢迎不同结论。只要讲得出道理，尖锐一点也没关系。",
  },
  {
    icon: "ri-shield-star-line",
    title: "对事不对人",
    desc: "讨论聚焦现象本身，拒绝人身攻击与无依据揣测，让每一层都值得读。",
  },
];

export default function CommunitySection() {
  return (
    <section id="community" className="relative overflow-hidden bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-lg border border-background-200/80">
              <img
                src="https://readdy.ai/api/search-image?query=people%20silhouettes%20chatting%20around%20a%20table%20in%20a%20dim%20late%20night%20cafe%20with%20warm%20hanging%20lights%2C%20bokeh%20in%20background%2C%20cinematic%20moody%20photograph%2C%20amber%20glow%2C%20film%20grain%2C%20high%20detail&width=1200&height=900&seq=yc-community-01&orientation=landscape"
                alt="深夜小馆里围坐讨论的人群剪影，象征深夜吃瓜的社区氛围"
                title="深夜吃瓜 - 讨论圈社区氛围"
                className="h-[300px] w-full object-cover object-top md:h-[420px]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 rounded-lg border border-background-300/30 bg-background-950/60 p-4 backdrop-blur">
                <p className="text-sm leading-relaxed text-foreground-200">
                  「瓜要一起吃，话要当面聊。」—— 这是深夜吃瓜从第一天起就写在首页的话。
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={80}>
            <span className="flex items-center gap-2 text-xs tracking-[0.3em] text-accent-500">
              <i className="ri-group-line" />
              ABOUT THE CLUB
            </span>
            <h2 className="heading-serif mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
              一个认真聊天的地方，而不是又一个吵架现场
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500 md:text-base">
              深夜吃瓜不是资讯搬运站，也不是只看热闹的围观席。我们把每个热话题做成一个完整的讨论区：有事实梳理，有观点楼层，也有你最想看的评论区。你可以全程潜水，也可以随时加入。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {principles.map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200/80 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-500">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <h3 className="heading-serif mt-3 text-base font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3">
          {members.slice(0, 3).map((member, index) => (
            <Reveal key={member.id} delay={index * 60}>
              <figure className="h-full rounded-lg border border-background-200/80 bg-background-50 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-sm font-medium text-primary-500">
                    {member.avatar}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{member.name}</p>
                    <p className="text-xs text-foreground-500">{member.joined}</p>
                  </div>
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-foreground-600">
                  {member.quote}
                </blockquote>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}